// Deterministic helpers for generating believable, stable dummy data.
// Seeded so the demo looks identical on every reload (good for screenshots).

// Mulberry32 seeded PRNG -> deterministic "random" in [0,1)
export function makeRng(seed: number) {
    let a = seed >>> 0;
    return function () {
        a |= 0; a = (a + 0x6d2b79f5) | 0;
        let t = Math.imul(a ^ (a >>> 15), 1 | a);
        t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
        return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
}

// hash a string to a stable 32-bit seed
export function hashSeed(str: string) {
    let h = 2166136261 >>> 0;
    for (let i = 0; i < str.length; i++) {
        h ^= str.charCodeAt(i);
        h = Math.imul(h, 16777619);
    }
    return h >>> 0;
}

export const round2 = (n: number) => Math.round(n * 100) / 100;
export const round0 = (n: number) => Math.round(n);

// random float in [min,max]
export const rf = (rng: () => number, min: number, max: number) => min + (max - min) * rng();
// random int in [min,max] inclusive
export const ri = (rng: () => number, min: number, max: number) => Math.floor(min + (max - min + 1) * rng());
// gaussian-ish jitter around 1.0 (0.85..1.15 typical) for organic day-to-day variance
export const jitter = (rng: () => number, spread = 0.15) => 1 + (rng() * 2 - 1) * spread;

// smooth weekly seasonality multiplier for a given day index (weekends dip a bit)
export function weekdayFactor(dayOfWeek: number) {
    // 0=Sun ... 6=Sat
    const table = [0.86, 1.05, 1.08, 1.06, 1.04, 1.0, 0.9];
    return table[dayOfWeek];
}
